import { render, staticRenderFns } from "./SmsBroadcastEmptyState.vue?vue&type=template&id=37230272&scoped=true"
import script from "./SmsBroadcastEmptyState.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastEmptyState.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastEmptyState.vue?vue&type=style&index=0&id=37230272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37230272",
  null
  
)

export default component.exports